'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _svg = require('../../utils/svg.utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var controls = (0, _svg.getSvgControls)();
var Svg = controls.Svg,
    Path = controls.Path;

var HeatingThermostat = function (_React$Component) {
    _inherits(HeatingThermostat, _React$Component);

    function HeatingThermostat() {
        _classCallCheck(this, HeatingThermostat);

        return _possibleConstructorReturn(this, (HeatingThermostat.__proto__ || Object.getPrototypeOf(HeatingThermostat)).apply(this, arguments));
    }

    _createClass(HeatingThermostat, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                Svg,
                { width: '26', height: '32', viewBox: '0 0 26 32' },
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M12.797 28.797C5.73 28.797 0 23.067 0 16S5.73 3.203 12.797 3.203c7.068 0 12.797 5.73 12.797 12.797s-5.73 12.797-12.797 12.797zm0-23.035C7.143 5.762 2.56 10.346 2.56 16s4.583 10.238 10.237 10.238S23.035 21.654 23.035 16 18.45 5.762 12.797 5.762zm6.398 11.518c-.706 0-1.28-.573-1.28-1.28s.573-1.28 1.28-1.28c.706 0 1.28.573 1.28 1.28s-.573 1.28-1.28 1.28zm-2.777-4.9c-.233-.23-.378-.552-.378-.906 0-.706.573-1.28 1.28-1.28s1.28.573 1.28 1.28c0 .354-.145.676-.378.907-.232.23-.55.373-.902.373s-.67-.142-.902-.372zm-1.062 8.74c0 1.413-1.145 2.558-2.56 2.558s-2.558-1.145-2.558-2.56v-.007h-.013l.026-.087c.012-.43.134-.83.34-1.175l2.195-7.667 2.2 7.625c.23.367.37.814.372 1.293v.02zm-2.56-10.24c-.705 0-1.28-.572-1.28-1.28s.574-1.28 1.28-1.28c.707 0 1.28.574 1.28 1.28s-.572 1.28-1.28 1.28zm-5.425 1.5c-.232-.23-.377-.552-.377-.906 0-.706.573-1.28 1.28-1.28s1.28.573 1.28 1.28c0 .354-.145.676-.377.907-.232.23-.55.373-.902.373s-.67-.142-.902-.372zM7.68 16c0 .706-.573 1.28-1.28 1.28s-1.28-.573-1.28-1.28c0-.706.573-1.28 1.28-1.28s1.28.573 1.28 1.28z' })
            );
        }
    }]);

    return HeatingThermostat;
}(_react2.default.Component);

HeatingThermostat.propTypes = {
    fill: _react2.default.PropTypes.string
};

exports.default = HeatingThermostat;


//////////////////
// WEBPACK FOOTER
// ./~/pluton-assets/lib/icons/svg/heating-thermostat.js
// module id = 1105
// module chunks = 0